import axios, { InternalAxiosRequestConfig } from 'axios';

// Функция для получения CSRF токена из cookie
const getCsrfToken = (): string | null => {
  const name = 'XSRF-TOKEN';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

/**
 * КАРДИНАЛЬНОЕ РЕШЕНИЕ: Определение API URL в runtime на основе текущего домена
 * Не зависит от переменных окружения
 */
const getApiBaseUrl = (): string => {
  // Если мы в браузере, определяем по текущему домену
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Если localhost или 127.0.0.1 - используем localhost:3001
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
      return 'http://localhost:3001/api';
    }
    
    // Для всех остальных случаев - используем относительный путь
    return '/api';
  }
  
  // Fallback для SSR/тестов
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl && envUrl.startsWith('/')) {
    return envUrl;
  }
  
  const isDev = import.meta.env.DEV === true || import.meta.env.MODE === 'development';
  return isDev ? 'http://localhost:3001/api' : '/api';
};

// Создаем экземпляр axios с базовым URL
export const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Включаем отправку cookies
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-CSRF-Token'
});

// Токены теперь в httpOnly cookies, они отправляются автоматически
// Не нужно устанавливать Authorization заголовок

// Request interceptor для добавления CSRF токена
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Добавляем CSRF токен для POST, PUT, DELETE, PATCH запросов
    const needsCsrf = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(config.method?.toUpperCase() || '');
    const isExemptPath = config.url?.includes('/auth/login') || 
                        config.url?.includes('/auth/register') ||
                        config.url?.includes('/csrf-token');
    
    if (needsCsrf && !isExemptPath) {
      const csrfToken = getCsrfToken();
      if (csrfToken && config.headers) {
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Добавляем перехватчик для обработки ошибок
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Перенаправляем только если мы не на публичной странице
      const publicPaths = ['/tournaments', '/tournament'];
      const currentPath = window.location.pathname;
      const isPublicPath = publicPaths.some(path => currentPath.startsWith(path));
      if (!isPublicPath) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
